import { render, staticRenderFns } from "./Temporary.vue?vue&type=template&id=76d67894&scoped=true"
import script from "./Temporary.vue?vue&type=script&lang=js"
export * from "./Temporary.vue?vue&type=script&lang=js"
import style0 from "./Temporary.vue?vue&type=style&index=0&id=76d67894&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d67894",
  null
  
)

export default component.exports